import { render, staticRenderFns } from "./ConfigSAML2.vue?vue&type=template&id=62801b35&scoped=true&"
import script from "./ConfigSAML2.vue?vue&type=script&lang=js&"
export * from "./ConfigSAML2.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSAML2.vue?vue&type=style&index=0&id=62801b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62801b35",
  null
  
)

export default component.exports